"use strict";

var LoggerInstance = require("js-logger").get("CheckoutActions");

var CheckoutApi = require("./CheckoutApi");
var CheckoutConstants = require("./CheckoutConstants");
var CheckoutStore = require("./CheckoutStore");
var DonationUpsellHelper = require("./DonationUpsellHelper");
var ShippingHelper = require("./ShippingHelper");
var TaxHelper = require("./TaxHelper");

var AccountActions = require("../accountComponents/AccountActions");
var AccountFormHelper = require("../accountComponents/AccountFormHelper");
var SavedPaymentHelper = require("../accountComponents/SavedPaymentHelper");

var ActionsHelper = require("../actions/ActionsHelper");

var Spinner = require("../client/Spinner");

var CheckoutHelper = require("../commonComponents/CheckoutHelper");
var PaymentHelper = require("../commonComponents/PaymentHelper");
var ValidationHelper = require("../commonComponents/ValidationHelper");

var WizardConstants = require("../constants/WizardConstants");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var BootstrapPrompt = require("../shared/BootstrapPrompt");
var LinkMessageHelper = require("../shared/LinkMessageHelper");

var CheckoutActions = {
	getCartDonations: function () {
		return CheckoutStore.getCartDonations();
	},

	getSaveForLaterCartDonations: function () {
		return CheckoutStore.getSaveForLaterCartDonations();
	},

	applyCoupon: function(event) {
		event = this._getEventOrReturn(event, "Apply Coupon called successfully.");
		if (!event) {
			return;
		}

		var couponCode = $("[data-component='applyCouponForm.input']").val();

		// If they didn't enter a coupon code, don't try and process it.
		if (!couponCode) {
			event.preventDefault();
			BootstrapPrompt.alert(CheckoutStore.getWizardValue(
				WizardConstants.WIZARDS.CHECKOUT_MESSAGES,
				WizardConstants.CHECKOUT_MESSAGE_FIELDS.INVALID_COUPON_CODE
			));
			return;
		}

		event.preventDefault();
		event.stopPropagation();

		if (CheckoutStore.isShoppingCart()) {
			this._applyCartCoupon(couponCode);
		} else {
			this._applyOnePageCoupon(couponCode);
		}
	},

	_applyCartCoupon: function(couponCode) {
		var cartType = CheckoutStore.getCartType();

		// get account address information
		var address = AccountFormHelper.serializeCreateAccountFormOnly({
			createAddressIfNotExists: true
		}).address;

		CheckoutApi.applyCoupon({
			cartType: cartType,
			country: address.country,
			couponCode: couponCode,
			postalCode: address.postalCode
		}).done(() => {
			window.location.reload();
			return false;
		}).fail((jqXHR) => {
			var systemError = jqXHR.responseJSON.message;
			var displayableError = "";

			if (systemError === Constants.COUPON_ERRORS.GEO_RESTRICTION_INFO_NEEDED) {
				displayableError = CheckoutStore.getWizardValue(
					WizardConstants.WIZARDS.COUPON_DISPLAY_MESSAGES,
					WizardConstants.COUPON_MESSAGE_FIELDS.GEOGRAPHIC_ERROR);
			} else {
				displayableError = CheckoutStore.getWizardValue(
					WizardConstants.WIZARDS.COUPON_DISPLAY_MESSAGES,
					WizardConstants.COUPON_MESSAGE_FIELDS.DEFAULT_ERROR);
			}

			BootstrapPrompt.alert(displayableError);
			return false;
		});
	},

	_applyOnePageCoupon: function(couponCode) {
		var productCode = CheckoutStore.get("productCode");
		CheckoutHelper.getCheckoutData().always(cartData => {
			CheckoutApi.applyOnePageCoupon({
				cart: cartData,
				couponCode: couponCode
			}).done((data) => {
				// first, clear the UI
				var discountAmount = data.discountAmount || null;
				var freeShippingMethod = data.freeShippingMethod || null;
				var freeShippingMethodDescription = data.freeShippingMethodDescription || null;

				$("[data-component='applyCouponForm.input']").val("");
				this.updateCouponCodeUI({
					couponCode: null,
					productCode
				});

				// second, update session storage
				if (discountAmount) {
					sessionStorage.setItem(`currentCoupon_${productCode}`, couponCode.toUpperCase());
				} else {
					sessionStorage.removeItem(`currentCoupon_${productCode}`);
				}

				// next, update data in the store.
				// this call will handle updating selected/free shipping
				Dispatcher.dispatch({
					actionType: Constants.CART_UPDATE_PRODUCT_OPCO_DISCOUNT,
					freeShippingMethod: freeShippingMethod,
					freeShippingMethodDescription: freeShippingMethodDescription,
					productDiscount: discountAmount
				});

				// last, update UI
				this.updateCouponCodeUI({
					couponCode: discountAmount ? couponCode.toUpperCase() : null,
					productCode
				});

				return false;
			}).fail((jqXHR) => {
				// check error message
				var systemError = jqXHR.responseJSON.message;
				var displayableError = "";

				// if we've failed, clear out coupon code.
				this._removeCoupon();

				if (systemError === Constants.COUPON_ERRORS.GEO_RESTRICTION_INFO_NEEDED) {
					displayableError = CheckoutStore.getWizardValue(
						WizardConstants.WIZARDS.COUPON_DISPLAY_MESSAGES,
						WizardConstants.COUPON_MESSAGE_FIELDS.GEOGRAPHIC_ERROR);
				} else {
					displayableError = CheckoutStore.getWizardValue(
						WizardConstants.WIZARDS.COUPON_DISPLAY_MESSAGES,
						WizardConstants.COUPON_MESSAGE_FIELDS.DEFAULT_ERROR);
				}

				BootstrapPrompt.alert(displayableError);
				return false;
			});
		});
	},

	reapplyOnePageCoupon: function(isInitialization) {
		// Determine if we've already initialized this
		var couponInitialized = CheckoutStore.get("couponInitialized");
		if (isInitialization && couponInitialized) {
			return;
		}

		var productCode = CheckoutStore.get("productCode");
		var couponCode = sessionStorage.getItem(`currentCoupon_${productCode}`);

		if (couponCode) {
			this._applyOnePageCoupon(couponCode);
			this.updateCouponCodeUI({
				couponCode,
				productCode
			});
		}

		if (isInitialization) {
			CheckoutStore.couponHasBeenInitialized();
		}
	},

	updateCouponCodeUI: function(options) {
		options = options || {};
		var productCode = options.productCode || CheckoutStore.get("productCode");
		var couponCode = options.couponCode || sessionStorage.getItem(`currentCoupon_${productCode}`);

		var $currentCouponComponent = $("[data-component='currentCoupon']");
		var $couponLabel = $("[data-dynamic-property='coupon']");

		if (couponCode) {
			$couponLabel.html(couponCode);
			$currentCouponComponent.show();
		} else {
			$currentCouponComponent.hide();
		}
	},

	isDesignMode: function() {
		return CheckoutStore.get("isDesignMode");
	},

	removeCoupon: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("removeCouponLink"));
		if (!event) {
			return;
		}

		this._removeCoupon();
	},

	_removeCoupon: function() {
		if (CheckoutStore.isShoppingCart()) {
			var cartType = CheckoutStore.getCartType();

			CheckoutApi.applyCoupon({
				cartType: cartType,
				couponCode: null
			}).done(() => {
				// Coupon removed successfully
				window.location.reload();
				return false;
			}).fail((jqXHR) => {
				// Coupon application failed, show message.
				BootstrapPrompt.alert(jqXHR.responseJSON.message);
				return false;
			});
		} else {
			var productCode = CheckoutStore.get("productCode");
			this.removeOpcoCoupon(productCode);
			Dispatcher.dispatch({
				actionType: Constants.CART_UPDATE_PRODUCT_OPCO_DISCOUNT,
				productDiscount: 0
			});

			this.updateCouponCodeUI({ productCode });
		}
	},

	removeOpcoCoupon: function(productCode) {
		if (!CheckoutStore.isShoppingCart()) {
			productCode = productCode || CheckoutStore.get("productCode");
			sessionStorage.removeItem(`currentCoupon_${productCode}`);
		}
	},

	removeDonationFromCart: function(cartItemId) {
		CheckoutActions.removeFromCart(cartItemId, Constants.CART_ITEM_PROJECT);
		return false;
	},

	removeDonationPremiumFromCart: function(cartItemId) {
		//Cannot do normal process for Ctrl+click because no event is passed in
		//	Using window.event because this works in Chrome and we are saying the designer only works in Chrome.
		if (this.isDesignMode()) {
			this._getEventOrReturn(window.event, LinkMessageHelper.linkMessageMapper("removePremium"));
			return;
		}

		CheckoutActions.updateDonation(cartItemId, { removePremium: true });
		return false;
	},

	removeProductFromCart: function(cartItemId) {
		CheckoutActions.removeFromCart(cartItemId, Constants.CART_ITEM_PRODUCT);
		return false;
	},

	removeRegistrationFromCart: function(cartItemId) {
		CheckoutActions.removeFromCart(cartItemId, Constants.CART_ITEM_EVENT);
		return false;
	},

	removeSubscriptionFromCart: function(cartItemId) {
		CheckoutActions.removeFromCart(cartItemId, Constants.CART_ITEM_SUBSCRIPTION);
		return false;
	},

	moveToSaveForLater: function(event, cartItemId) {
		var itemType = this._findItemType(event);
		var cartItem = CheckoutStore.getItem(cartItemId, itemType);

		if (itemType === Constants.CART_ITEM_PROJECT && cartItem.groupId) {
			var groupItems = CheckoutStore.getGiftGroupDonationsByGroupId(cartItem.groupId);
			var groupItemsCount = groupItems.length;

			if (groupItemsCount > 1) {
				var minimumDonationAmount = CheckoutStore.getMinimumDonationAmount(cartItemId);
				var donationGroupTotal = CheckoutStore.getDonationGroupTotal(cartItemId, { isRemoving: true });

				if (donationGroupTotal < minimumDonationAmount)
				{
					this.applyInsufficientGiftGroupAmountStyling(cartItemId);

					Spinner.removeSpinner();
					BootstrapPrompt.alert(CheckoutStore.getWizardValue(
						WizardConstants.WIZARDS.CHECKOUT_MESSAGES,
						WizardConstants.CHECKOUT_MESSAGE_FIELDS.GIFT_GROUP_AMOUNT_INSUFFICIENT,
						{ formattedAmount: ActionsHelper.formatAmount(minimumDonationAmount, true) }
					));

					return;
				}
			}
		}

		CheckoutActions.moveToCart(event, cartItemId, Constants.CART_TYPES.SAVE_FOR_LATER, LinkMessageHelper.linkMessageMapper("toSaveForLater"));
	},

	moveToShoppingCart: function(event, cartItemId) {
		var itemType = this._findItemType(event);
		var cartItem = CheckoutStore.getItem(cartItemId, itemType);

		if (itemType === Constants.CART_ITEM_PROJECT && cartItem.groupId) {
			var minimumDonationAmount = CheckoutStore.getMinimumDonationAmount(cartItemId);

			if (cartItem.amount < minimumDonationAmount)
			{
				Spinner.removeSpinner();
				BootstrapPrompt.alert(CheckoutStore.getWizardValue(
					WizardConstants.WIZARDS.CHECKOUT_MESSAGES,
					WizardConstants.CHECKOUT_MESSAGE_FIELDS.GIFT_AMOUNT_INSUFFICIENT,
					{ formattedAmount: ActionsHelper.formatAmount(minimumDonationAmount, true) }
				));

				return;
			}
		}

		CheckoutActions.moveToCart(event, cartItemId, Constants.CART_TYPES.SHOPPING_CART, LinkMessageHelper.linkMessageMapper("toShoppingCart"));
	},

	moveToCart: function(event, cartItemId, cartType, designerMessage) {
		try {
			event = CheckoutActions._getEventOrReturn(event, designerMessage, /*preventDefaultInDesignMode*/false);
			if (!event) {
				return;
			}

			var itemType = CheckoutActions._findItemType(event);
			if (itemType === null) {
				return;
			}

			Spinner.showSpinner();

			CheckoutApi.moveToCart(cartItemId, itemType, cartType).done(() => {
				window.location.reload();
			}).fail((jqXHR, textStatus, errorThrown) => {
				Spinner.removeSpinner();
				BootstrapPrompt.alert(CheckoutStore.getWizardValue(
					WizardConstants.WIZARDS.CHECKOUT_MESSAGES,
					WizardConstants.CHECKOUT_MESSAGE_FIELDS.ITEM_MOVE_FAILED
				));
			});
		} catch (exception) {
			Spinner.removeSpinner();
			LoggerInstance.error(exception);
		} finally {
			return false;
		}
	},

	removeFromCart: function(cartItemId, itemType) {
		//Cannot do normal process for Ctrl+click because no event is passed in
		//	Using window.event because this works in Chrome and we are saying the designer only works in Chrome.
		if (this.isDesignMode()) {
			this._getEventOrReturn(window.event, LinkMessageHelper.linkMessageMapper("removeFromCart"));
			return;
		}

		Spinner.showSpinner();

		Dispatcher.dispatch({
			actionType: CheckoutConstants.CART_REMOVE_PENDING
		});

		var cartItem = CheckoutStore.getItem(cartItemId, itemType);

		if (itemType === Constants.CART_ITEM_PROJECT &&
			cartItem.groupId && cartItem.cartType !== Constants.CART_TYPES.SAVE_FOR_LATER) {
			var groupItems = CheckoutStore.getGiftGroupDonationsByGroupId(cartItem.groupId);
			var groupItemsCount = groupItems.length;

			if (groupItemsCount > 1) {
				var minimumDonationAmount = CheckoutStore.getMinimumDonationAmount(cartItemId);
				var donationGroupTotal = CheckoutStore.getDonationGroupTotal(cartItemId, { isRemoving: true });

				if (donationGroupTotal < minimumDonationAmount)
				{
					Dispatcher.dispatch({
						actionType: CheckoutConstants.CART_REMOVE_FAILED
					});

					this.applyInsufficientGiftGroupAmountStyling(cartItemId);

					Spinner.removeSpinner();
					BootstrapPrompt.alert(CheckoutStore.getWizardValue(
						WizardConstants.WIZARDS.CHECKOUT_MESSAGES,
						WizardConstants.CHECKOUT_MESSAGE_FIELDS.GIFT_GROUP_AMOUNT_INSUFFICIENT,
						{ formattedAmount: ActionsHelper.formatAmount(minimumDonationAmount, true) }
					));

					return;
				}
			}
		}

		CheckoutApi.removeFromCart(cartItemId, itemType, cartItem.cartType || CheckoutStore.getCartType())
			.done(() => {
				Dispatcher.dispatch({
					actionType: CheckoutConstants.CART_REMOVE_SUCCESS,
					cartItemId,
					itemType
				});

				window.location.reload();
			}).fail((jqXHR, textStatus, errorThrown) => {
				Dispatcher.dispatch({
					actionType: CheckoutConstants.CART_REMOVE_FAILED
				});

				Spinner.removeSpinner();
				BootstrapPrompt.alert(CheckoutStore.getWizardValue(
					WizardConstants.WIZARDS.CHECKOUT_MESSAGES,
					WizardConstants.CHECKOUT_MESSAGE_FIELDS.ITEM_REMOVE_FAILED
				));
			});
	},

	applyInsufficientGiftGroupAmountStyling: function(cartItemId) {
		CheckoutHelper.applyInsufficientGiftGroupAmountStyling(cartItemId);
	},

	setDonationAmount: function(cartItemId, amount) {
		CheckoutActions.updateAmount(cartItemId, Constants.CART_ITEM_PROJECT, amount);
	},

	updateAmount: function(cartItemId, itemType, amount) {
		Dispatcher.dispatch({
			actionType: CheckoutConstants.CART_UPDATE_AMOUNT,
			cartItemId,
			itemType,
			amount
		});
	},

	setDonationChargeToday: function(cartItemId, chargeToday) {
		CheckoutActions.updateChargeToday(cartItemId, Constants.CART_ITEM_PROJECT, chargeToday);
	},

	updateChargeToday: function(cartItemId, itemType, chargeToday) {
		Dispatcher.dispatch({
			actionType: Constants.CART_UPDATE_CHARGE_TODAY,
			cartItemId,
			itemType,
			chargeToday
		});
	},

	setDonationFrequency: function(cartItemId, frequency) {
		CheckoutActions.updateFrequency(cartItemId, Constants.CART_ITEM_PROJECT, frequency);
	},

	updateFrequency: function(cartItemId, itemType, frequency) {
		Dispatcher.dispatch({
			actionType: Constants.CART_UPDATE_FREQUENCY,
			cartItemId,
			itemType,
			frequency
		});
	},

	setDonationUseOnDay: function(cartItemId, useOnDay) {
		CheckoutActions.updateUseOnDay(cartItemId, Constants.CART_ITEM_PROJECT, useOnDay);
	},

	updateUseOnDay: function(cartItemId, itemType, useOnDay) {
		Dispatcher.dispatch({
			actionType: Constants.CART_UPDATE_USE_ON_DAY,
			cartItemId,
			itemType,
			useOnDay
		});
	},

	setProductQuantity: function(cartItemId, quantity) {
		CheckoutActions.updateQuantity(cartItemId, Constants.CART_ITEM_PRODUCT, quantity);
	},

	updateQuantity: function(cartItemId, itemType, quantity) {
		Dispatcher.dispatch({
			actionType: Constants.CART_UPDATE_QUANTITY,
			cartItemId,
			itemType,
			quantity
		});

		this.reapplyOnePageCoupon();
	},

	updateDonation: function(cartItemId, options) {
		options = options || {};
		Spinner.showSpinner();

		var cartType = CheckoutStore.getCartType();
		var donation = CheckoutStore.getCartDonationForUpdate(cartItemId, options);

		if (!donation) {
			LoggerInstance.debug("Donation not found or not marked as dirty.");
			Spinner.removeSpinner();
			return;
		}

		if (donation.cartType) {
			cartType = donation.cartType;
			delete donation.cartType;
		}

		if (options.removePremium) {
			donation.premium = null;
		}

		if (options.newStartDate) {
			donation.startDate = options.newStartDate;
		}

		Dispatcher.dispatch({
			actionType: CheckoutConstants.CART_UPDATE_PENDING,
			cartItemId
		});

		CheckoutApi.updateCartDonation(cartType, donation)
			.done(() => {
				Dispatcher.dispatch({
					actionType: CheckoutConstants.CART_UPDATE_SUCCESS,
					cartItemId
				});

				window.location.reload();
			}).fail(message => {
				Dispatcher.dispatch({
					actionType: CheckoutConstants.CART_UPDATE_FAILED,
					cartItemId,
					message
				});

				Spinner.removeSpinner();
		});
	},

	updateProduct: function(cartItemId) {
		Spinner.showSpinner();

		var cartType = CheckoutStore.getCartType();
		var product = CheckoutStore.getCartProductForUpdate(cartItemId);

		if (!product) {
			LoggerInstance.debug("Product not found or not marked as dirty.");
			Spinner.removeSpinner();
			return;
		}

		if (product.cartType) {
			cartType = product.cartType;
			delete product.cartType;
		}

		Dispatcher.dispatch({
			actionType: CheckoutConstants.CART_UPDATE_PENDING,
			cartItemId
		});

		CheckoutApi.updateCartProduct(cartType, product)
			.done(() => {
				Dispatcher.dispatch({
					actionType: CheckoutConstants.CART_UPDATE_SUCCESS,
					cartItemId
				});

				window.location.reload();
			}).fail(message => {
				Dispatcher.dispatch({
					actionType: CheckoutConstants.CART_UPDATE_FAILED,
					cartItemId,
					message
				});

				Spinner.removeSpinner();
		});
	},

	// Saved Payments
	deleteSavedPayment: function (paymentRecordId) {
		SavedPaymentHelper.deleteSavedPayment(paymentRecordId);
	},

	showAddNewPayment: function(event) {
		SavedPaymentHelper.handleAddNewPaymentLinkClick(event);
		CheckoutStore.setHasNewPaymentBeenShown();
	},

	initializeCartRecurringStartDateDropdowns($dropdowns) {
		// update donation cart item
		this.updateDonation();
	},

	initializeStore: function(action) {
		PaymentHelper.initializeSaveForLaterCheckbox();
		Dispatcher.dispatch(Object.assign({}, action, { actionType: Constants.CHECKOUT_INITIALIZE }));

		if (!action.isDesignMode) {
			AccountFormHelper.initializeAccountFormListeners(() => {
				if (this.isPayPalSupported()) {
					this.disablePayPal();

					//Add Listener for required fields that could trigger validation errors.
					//	When these fields change, we want to evaluate if our form is valid to submit to PayPal.
					//	The list of components here comes from CheckoutStore.updatePayPalButtonState()
					$("[data-component='accountDemographicsForm'],[data-component='createAccountForm'],[data-component='accountMediaForm'],[data-component='createGiftAccountForm'],[data-component='otherAddresses.addForm']")
						.find(":input").change(() => {
							Dispatcher.dispatch({ actionType: CheckoutConstants.VALIDATE_PAYPAL_CHECKOUT });
						});
				}

				ShippingHelper.updateShipping();
				Dispatcher.dispatch({ actionType: CheckoutConstants.VALIDATE_PAYPAL_CHECKOUT });
			});

			ShippingHelper.initializeShippingListeners();
			TaxHelper.initializeTaxListeners();
			document.addEventListener("DOMContentLoaded", function (event) {
				SavedPaymentHelper.initializeSavedPayments(/*isCheckout*/true);
			});

			DonationUpsellHelper.initializeDonationUpsell();

			//Do not like having to do this, but the ProductStore has the event for quantity changing, but Checkout cannot reference that
			//	We are listening to an event one time that the quantity react component triggers to let us know that we can add our change listener on the quantity input.
			$("body").one("mainProductQuantityMounted", () => {
				$("input.main-product-quantity").change(() => {
					CheckoutStore.setOPCOSubtotal();
				});
			});

			// update coupon code UI if we're in OPCO
			if (!CheckoutStore.isShoppingCart()) {
				this.reapplyOnePageCoupon(/* isInitialization */ true);
			}
		}
	},

	processCreateAccountAndCheckout: function(event) {
		event = CheckoutActions._getEventOrReturn(event, "Create Account and Checkout called successfully.");
		if (!event) {
			return;
		}

		var hasCreateAccountAndCheckout = $("[data-component=createAccountAndCheckout]").length >= 1;
		if (!hasCreateAccountAndCheckout) {
			LoggerInstance.error("Create Account & Checkout Component not found on page, but processing was attempted.");
			return;
		}

		var checkoutValidationType = Constants.CHECKOUT_VALIDATION_TYPES.CREATE_ACCOUNT_AND_CHECKOUT;
		var addressStandardizationOptions = {
			checkoutStoreRef: CheckoutStore,
			primaryAddressFormName: "createAccountForm",
			validateBillingAddress: true
		};
		var checkoutSubmissionOptions = {"validateOneTimePassword": true};

		return this._validateAndSubmitCheckout(event, checkoutValidationType, addressStandardizationOptions, checkoutSubmissionOptions);
	},

	// This method is being called directly via an onclick handler from *.cshml
	processSavedPaymentCheckout: function(event) {
		event = CheckoutActions._getEventOrReturn(event, "Saved Payent Checkout called successfully.", /*preventDefaultInDesignMode*/false);
		if (!event) {
			return;
		}

		var hasSavedPaymentCheckout = $("[data-component=savedPayments]").length >= 1;
		if (!hasSavedPaymentCheckout) {
			LoggerInstance.error("Saved Payments Component not found on page, but processing was attempted.");
			return;
		}

		var checkoutValidationType = Constants.CHECKOUT_VALIDATION_TYPES.SAVED_PAYMENT_CHECKOUT;
		var addressStandardizationOptions = { checkoutStoreRef: CheckoutStore, validateBillingAddress: true };
		var checkoutSubmissionOptions = {};

		return this._validateAndSubmitCheckout(event, checkoutValidationType, addressStandardizationOptions, checkoutSubmissionOptions);
	},

	_validateAndSubmitCheckout: function (event, checkoutValidationType, addressStandardizationOptions, checkoutSubmissionOptions) {
		try {
			var components = this.getComponentsForCheckoutValidation(checkoutValidationType);

			Spinner.showSpinner();
			this.validateCheckout(event, { components, validateOneTimePassword: true }, addressStandardizationOptions).always(validationResult => {
				if (!validationResult.isValid) {
					Spinner.removeSpinner();
					return;
				}

				var shouldApplyPaymentInformation = true;
				CheckoutHelper.getCheckoutData(event, shouldApplyPaymentInformation).always(dataToSend => {
					if (!dataToSend) {
						Spinner.removeSpinner();
						return;
					}

					if (CheckoutActions.getOneTimePasswordRequired ()  && checkoutSubmissionOptions.validateOneTimePassword) {
						AccountFormHelper.validateOneTimePassword(
							event
						).done(oneTimePassword => {
							dataToSend.verificationCode = oneTimePassword;
							CheckoutActions._submitCheckout(dataToSend, checkoutSubmissionOptions);
						}).fail(() => {
							Spinner.removeSpinner();
						});
					} else {
						CheckoutActions._submitCheckout(dataToSend, checkoutSubmissionOptions);
					}
				});
			});
		} catch (exception) {
			LoggerInstance.error(exception);
			Spinner.removeSpinner();
		} finally {
			return false;
		}
	},

	// Returns an array of all components that should be validated during the checkout process.
	// Each Checkout Validation Process calls this method to collect the components that need to be validated.
	getComponentsForCheckoutValidation: function (checkoutValidationType) {
		var components = this._getCommonComponentsForCheckoutValidation();

		switch (checkoutValidationType) {
			// Create Account and Checkout
			case Constants.CHECKOUT_VALIDATION_TYPES.CREATE_ACCOUNT_AND_CHECKOUT:
				components = [].concat([$("[data-component='createAccountAndCheckout']")], components);

				// If we're on a Product Page, validate the suggested donation
				if (this._isPageType(Constants.TANGIBLE_TYPES.PRODUCTS)) {
					components = [].concat([$("[data-component='suggestedDonationAmount']")], components);
				}

				break;

			// Saved Payment Checkout
			case Constants.CHECKOUT_VALIDATION_TYPES.SAVED_PAYMENT_CHECKOUT:
				var savedPaymentData = CheckoutHelper.savedPaymentComponentData();
				if (savedPaymentData && savedPaymentData.newSavedPayment) {
					//Need to validate the savedPayments.addNew component
					components = [].concat([$("[data-component='savedPayments.addNew']")], components);
				}
				break;

			// Alternate Button Checkout (PayPal, Apple Pay, Google Pay, etc.)
			case Constants.CHECKOUT_VALIDATION_TYPES.ALTERNATIVE_BUTTON_CHECKOUT:
				// The createAccountAndCheckout component includes the payment form, which should not be validated.
				// We only want to validate the createAccountForm portion in alternative button checkout flows.
				components = [].concat([$("[data-component='createAccountAndCheckout'] [data-component='createAccountForm']")], components);
				break;
			default:
				break;
		}

		return components;
	},

	_getCommonComponentsForCheckoutValidation: function () {
		var components = [
			$("[data-component='accountDemographicsForm']"),
			$("[data-component='accountMediaForm']")
		];

		// If a user has selected an alternate shipping address, those components should also be validated.
		switch ($("input[name='shipToAddressSelector']:checked").val()) {
			case "gift":
				components = [].concat([$("[data-component='createGiftAccountForm']")], components);
				break;
			case "other":
				components = [].concat([$("[data-component='otherAddresses.addForm']")], components);
				break;
			default:
				break;
		}

		// If checking out from a Secure Project or Pledge Page, the secure input should also be validated.
		var isSecurePage = this._isPageType(Constants.TANGIBLE_TYPES.SECURE_PROJECTS) || this._isPageType(Constants.TANGIBLE_TYPES.SECURE_PLEDGES);
		if (isSecurePage) {
			components = [].concat([$("[data-component='textInput'][data-data-binding='secureInput']")], components);
		}

		// If checking out from a Project or Pledge page, additional components should be validated.
		var isProjectOrPledgePage = this._isPageType(Constants.TANGIBLE_TYPES.PROJECTS) ||
			this._isPageType(Constants.TANGIBLE_TYPES.PLEDGES) ||
			isSecurePage;

		if (isProjectOrPledgePage) {
			var componentsToAdd = "[data-react-component-name='ButtonGiftArray'],[data-react-component-name='RadioGiftArray'],[data-react-component-name='SelectGiftArray'],[data-react-component-name='PledgeButtonGiftArray'],[data-react-component-name='PledgeRadioGiftArray'],[data-react-component-name='PledgeSelectGiftArray']";
			componentsToAdd += ",[data-component='buttonGiftAmount'],[data-component='radioGiftAmount'],[data-component='selectGiftAmount']";

			var elements = $(componentsToAdd).filter((index, element) => {
				var $element = $(element);
				return $element.parents().length == $element.parents().not("[data-component='category.project'],[data-component='carousel.project'],[data-component='category.pledge'],[data-component='carousel.pledge']").length;
			});
			components = [].concat(elements, components);
		}

		return components;
	},

	// This function returns a deferred object.  It will always resolve rather than reject the returned promise.
	// Resolves with an object: { isValid: (boolean), errorMessages: [(string), (string), ...] }
	validateCheckout: function (event, validationOptions, addressStandardizationOptions) {
		var addressCorrectionMessage = "Constituent will correct address";
		var deferred = new $.Deferred();

		validationOptions = validationOptions || {};
		addressStandardizationOptions = addressStandardizationOptions || {};
		addressStandardizationOptions.checkoutStoreRef = CheckoutStore;

		if (validationOptions.isDryRun) {
			validationOptions.currentInvalidComponents = $(".invalid");
		}

		//There were shopping cart errors when the page loaded
		var shoppingCartErrors = CheckoutActions.getShoppingCartErrors();
		if (CheckoutActions.getDoShoppingCartErrorToPreventCheckoutExist() && shoppingCartErrors.length) {
			if (!validationOptions.doNotShowAlert) {
				BootstrapPrompt.alert(shoppingCartErrors.join("<br>"));
			}

			this._failCheckoutValidation(deferred, validationOptions, shoppingCartErrors);

			return deferred;
		}

		ValidationHelper.validate(validationOptions)
			.always(validationResult => {
			// The Result of validate() can be different based on the options provided.
			// 1. A boolean value
			// 2. A validate Result object: { isValid: (boolean), errorMessages: [(string), (string), ...]}
			var isValid = validationResult === true || (validationResult && validationResult.isValid);
			var errorMessages = validationResult && validationResult.errorMessages || [];

			if (!isValid) {
				this._failCheckoutValidation(deferred, validationOptions, errorMessages);

				return;
			}

			if (validationOptions.requirePopulatedAccountForm && !AccountFormHelper.hasPopulatedAccountForm()) {
				// TODO - A Wizard Message should be here to let constituents know that an address is required in this case.
				// (This says that the address fields are required even if they were not configured as 'required' fields in the Layout Designer)
				this._failCheckoutValidation(deferred, validationOptions, errorMessages);

				return;
			}

			var isOptOut = false;
			if ($('input[name="projectPremiumsRadio"]').length) {
				isOptOut = $('input[name="projectPremiumsRadio"]:checked').parents("[data-component='projectPremiums.optOut']").length;
			}

			addressStandardizationOptions.bypassShippingValidation = validationOptions.allowShippingValidationBypass && (
				(CheckoutStore.get("checkoutType") === "PRODUCTS" && !CheckoutStore.get("hasShippableProducts")) ||
				isOptOut
			);

			AccountFormHelper.validateShippingAddress(
				event,
				addressStandardizationOptions
			).done(shippingAddressType => {
				var passwordVerificationResult = AccountActions.verifyCreateAccountPasswords(validationOptions.doNotShowAlert);
				if (!passwordVerificationResult.isVerified) {
					this._failCheckoutValidation(deferred, [validationOptions, ].concat(errorMessages, [passwordVerificationResult.errorMessage]));

					return;
				}

				var validateBillingAddress = () => {
					if (addressStandardizationOptions.validateBillingAddress && $("[id=addBillingAddress]").length) {
						// Verify the billing address if it is new
						window.SmartyStreets.verifyAddress("billingAddressesAdd").done(() => {
							deferred.resolve({
								isValid: true
							});
						}).fail(errorMessage => {
							if (errorMessage && errorMessage !== addressCorrectionMessage && !validationOptions.doNotShowAlert) {
								BootstrapPrompt.alert(errorMessage);
							}

							this._failCheckoutValidation(deferred, validationOptions, errorMessage !== addressCorrectionMessage ? [].concat(errorMessages, [errorMessage]) : errorMessages);

							return;
						});
					} else {
						deferred.resolve({
							isValid: true
						});
					}
				}

				var savedPaymentData = CheckoutHelper.savedPaymentComponentData();
				if (!savedPaymentData.savedPaymentCheckout && (shippingAddressType === "other" || shippingAddressType === "gift")) {
					// Verify the primary address if it has not already been verified as the shipping address.
					window.SmartyStreets.verifyAddress("createAccountForm").done(() => {
						validateBillingAddress();
					}).fail(errorMessage => {
						if (errorMessage && errorMessage !== addressCorrectionMessage && !validationOptions.doNotShowAlert) {
							BootstrapPrompt.alert(errorMessage);
						}

						this._failCheckoutValidation(deferred, validationOptions, errorMessage !== addressCorrectionMessage ? [].concat(errorMessages, [errorMessage]) : errorMessages);

						return;
					});
				} else {
					validateBillingAddress();
				}
			}).fail(errorMessage => {
				var isDisplayErrorMessage = errorMessage && errorMessage !== addressCorrectionMessage;

				if (isDisplayErrorMessage && !validationOptions.doNotShowAlert) {
					BootstrapPrompt.alert(errorMessage);
				}

				this._failCheckoutValidation(deferred, validationOptions, isDisplayErrorMessage ? [].concat(errorMessages, [errorMessage]) : errorMessages);

				return;
			});

		});

		return deferred;
	},

	validateWithReCAPTCHA: function () {
		var deferred = new $.Deferred();

		if (window.reCAPTCHA) {
			document.addEventListener("mouseup", CheckoutApi._removeCaptchaSpinner);

			$("#recaptcha").one("Success", (event, token) => {
				deferred.resolve({ reCAPTCHAResponseToken: token });
			});

			if (!window.callingReCAPTCHA) {
				grecaptcha.execute();
			}

			return deferred;
		} else {
			deferred.resolve({ reCAPTCHAResponseToken: null });
		}

		return deferred;
	},

	processPayPalPaymentPreCheckout: function() {
		var deferred = $.Deferred();
		try {
			Spinner.showSpinner();
			CheckoutHelper.getCheckoutData().always(cartData => {
				deferred.resolve(cartData);
			});
		} catch (exception) {
			LoggerInstance.error(exception);
			deferred.reject(exception);
		}
		return deferred;
	},

	updatePayPalButtonState: function(shouldMarkInvalidComponents) {
		var deferred = $.Deferred();
		try {
			if (CheckoutStore.get("isPayPalSupported")) {
				//Disable paypal without a message as a default
				//If validation fails at anytime, disable with a message.
				//If validation is successful, enable paypal.
				CheckoutStore.disablePayPal();

				if (CheckoutStore.get("errorsToPreventCheckoutExist")) {
					deferred.reject();
					return deferred;
				}

				var components = this.getComponentsForCheckoutValidation(Constants.CHECKOUT_VALIDATION_TYPES.ALTERNATIVE_BUTTON_CHECKOUT);

				// PayPal requires a populated address form, but allows the shipping address validation to be skipped if on non-shippable product page.
				// PayPal handles alerting constituents of errors, so we want to suppress the regular validation alerts.
				var validationOptions = {
					components: components,
					requirePopulatedAccountForm: true,
					allowShippingValidationBypass: true,
					isDryRun: !shouldMarkInvalidComponents,
					doNotShowAlert: true
				};

				var addressStandardizationOptions = {
					checkoutStoreRef: CheckoutStore,
					primaryAddressFormName: AccountFormHelper.getPrimaryAddressFormName()
				};

				this.validateCheckout(null, validationOptions, addressStandardizationOptions).always((validationResult) => {
					if (validationResult && validationResult.isValid) {
						CheckoutStore.enablePayPal();
						deferred.resolve();
					} else {
						CheckoutStore.disablePayPal(validationResult.errorMessages);
						deferred.reject();
					}
				});
			} else {
				deferred.resolve();
			}
		} catch (exception) {
			LoggerInstance.error(exception);
			deferred.reject();
		}
		return deferred;
	},

	// Submits checkout using a pre-tokenized payment from an Alternative Checkout Button (PayPal, Apple Pay, Google Pay, etc.)
	processPreTokenizedPaymentCheckout: function (paymentInformation, dataToSend, successCallback, failureCallback) {
		dataToSend = dataToSend || {};
		dataToSend.payment = paymentInformation;
		CheckoutActions._submitCheckout(dataToSend, { successCallback, failureCallback });
	},

	updateCartTotals: function(event) {
		event = this._getEventOrReturn(event, "Update Cart Totals called successfully.");
		if (!event) {
			return;
		}

		window.location.reload();
	},

	_findItemType: function(event) {
		var $element = $(event.target);

		if ($element.closest("[data-component='cart.populated.event']").length) {
			return Constants.CART_ITEM_EVENT;
		}
		if ($element.closest("[data-component='cart.populated.product']").length) {
			return Constants.CART_ITEM_PRODUCT;
		}
		if ($element.closest("[data-component='cart.populated.project']").length) {
			return Constants.CART_ITEM_PROJECT;
		}
		if ($element.closest("[data-component='cart.populated.subscription']").length) {
			return Constants.CART_ITEM_SUBSCRIPTION;
		}
		LoggerInstance.error("Item type could not be identified");
		return null;
	},

	_submitCheckout: function (dataToSend, options) {
		options = options || {};

		var successCallback = () => {
			this.removeOpcoCoupon();

			if (_.isFunction(options.successCallback)) {
				options.successCallback();
			}
		};

		var failureCallback = () => {
			if (_.isFunction(options.failureCallback)) {
				options.failureCallback();
			}
		};

		CheckoutHelper.completeCheckout(dataToSend, successCallback, failureCallback);
	},

	_failCheckoutValidation(deferred, validationOptions, errorMessages) {
		if (validationOptions.isDryRun) {
			$(".invalid").not(validationOptions.currentInvalidComponents).removeClass("invalid");
		}

		deferred.resolve({
			isValid: false,
			errorMessages: errorMessages
		});
	},

	_isPageType: function(pageTypeConstant) {
		return CheckoutStore.isPageType(pageTypeConstant);
	},

	_getEventOrReturn: function(event, isDesignModeMessage, preventDefaultInDesignMode) {
		return ActionsHelper.getEventOrReturn(event, CheckoutStore.get("isDesignMode"), isDesignModeMessage, preventDefaultInDesignMode);
	},

	getWizardValue(wizardName, wizardProperty) {
		return CheckoutStore.getWizardValue(
			wizardName,
			wizardProperty
		);
	},

	getPayPalErrorMessages() {
		return CheckoutStore.getPayPalErrorMessages();
	},

	setPayPalActions(actions, enabledOnLoad) {
		CheckoutStore.setPayPalActions(actions, enabledOnLoad);
	},

	isPayPalEnabled: function() {
		return CheckoutStore.isPayPalEnabled();
	},

	isPayPalSupported: function() {
		return CheckoutStore.get("isPayPalSupported");
	},

	disablePayPal: function() {
		CheckoutStore.disablePayPal();
	},

	getApplePayConfiguration: function () {
		return CheckoutStore.get("wizardApplePayConfiguration") || {};
	},

	getApplePayDisplayMessages: function () {
		return CheckoutStore.get("wizardApplePayDisplayMessages") || {};
	},

	getGooglePayConfiguration: function () {
		return CheckoutStore.get("wizardGooglePayConfiguration") || {};
	},

	getGooglePayDisplayMessages: function () {
		return CheckoutStore.get("wizardGooglePayDisplayMessages") || {};
	},

	getOneTimePasswordRequired: function () {
		return (CheckoutStore.get("wizardOneTimePasswordConfiguration") || {}).oneTimePasswordForGuestCheckoutEnabled === "Y"
	},

	getOneTimePasswordForGuestCheckoutMessages: function () {
		return CheckoutStore.get("wizardOneTimePasswordForGuestCheckoutMessages") || {};
	},

	getCheckoutDispatcher: function() {
		return CheckoutStore.getCheckoutDispatcher();
	},

	getCurrency: function () {
		return CheckoutStore.get("currency");
	},

	getShoppingCartErrors: function() {
		return CheckoutStore.get("errors") || [];
	},

	getDoShoppingCartErrorToPreventCheckoutExist() {
		return CheckoutStore.get("errorsToPreventCheckoutExist");
	},

	getTotalAmount() {
		return CheckoutStore.getTotalAmount();
	}
};

module.exports = CheckoutActions;
